// An icon for each off-campus program, beside its full name wherever the
// program is shown. Client-only, so it stays out of the mirrored program-workflow.
const PROGRAM_ICONS = Object.freeze({
  WE: 'solar:case-round-bold',
  CI: 'solar:square-academic-cap-2-bold',
  RAP: 'solar:sledgehammer-bold',
  GC: 'solar:leaf-bold',
});

const DEFAULT_PROGRAM_ICON = 'solar:case-round-bold';

/** The program's icon; a generic one for an unknown code. */
export function programIcon(programType) {
  return PROGRAM_ICONS[programType] || DEFAULT_PROGRAM_ICON;
}
